import React, {useState} from "react";
import {Button, Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ChildAssessmentStrip from "../sessions/ChildAssessmentStrip";

export default function EditAssessmentDialog({bookingId}) {

    const [openDialog, setOpenDialog] = useState(false);

    const handleEditButtonClick = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    const onAssessmentSubmitted = () => setOpenDialog(false);

    return <>
        <Button variant="contained" size="small" onClick={handleEditButtonClick}>Edit</Button>
        <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle>Edit Assessment</DialogTitle>
            <IconButton
              aria-label="close" onClick={handleCloseDialog}
              sx={{position: 'absolute', right: 20, top: 12, color: (theme) => theme.palette.grey[500]}}>
                <CloseIcon/>
            </IconButton>
            <DialogContent>
                <ChildAssessmentStrip bookingId={bookingId} onAssessmentSubmitted={onAssessmentSubmitted} compact/>
            </DialogContent>
        </Dialog>
    </>;
}